<template>
  <div :class="(elevated ? 'elevation-1 pb-1 ' : 'elevation-0 ') + containerClass"
       :style="style">

    <slot name="prepend"></slot>

    <fin-page-title v-if="icon || title" :icon="icon" :title="title" :class="'pb-5 '+contentClass"
                    v-style:paddingLeft="$valueByBreakpoint(paddingLeft)"
                    v-style:paddingRight="$valueByBreakpoint(paddingRight)"
                    style="display: inline-block; width: 100%;">
      <template #afterTitle>
        <slot name="afterTitle"></slot>
      </template>
      <template #actions>
        <slot name="actions" style="float: right"></slot>
        <v-btn v-if="showMoreBtn" text style="float: right" @click="showAllClicked">
          {{ showAllText }}
        </v-btn>
      </template>
    </fin-page-title>


    <div :class="contentClass"
         v-style:paddingLeft="$valueByBreakpoint(paddingLeft)"
         v-style:paddingRight="$valueByBreakpoint(paddingRight)">
      <slot>
        <span style="display: block; padding-top: 10px; padding-bottom: 10px;">&nbsp;</span>
      </slot>
    </div>

  </div>
</template>

<script>
import FinPageTitle from '@/components/pages/PageTitle'

export default {
  name: 'fin-content-section',
  components: {FinPageTitle},
  props: {
    // Styles
    elevated: {type: Boolean},
    dark: {type: Boolean},
    light: {type: Boolean},
    showMoreBtn: {type: Boolean},
    containerClass: {type: String, default: ''},
    contentClass: {type: String, default: ''},
    paddingRight: {
      type: Object,
      default: () => {
        return {}
      }
    },
    paddingLeft: {
      type: Object,
      default: () => {
        return {}
      }
    },

    // Content
    title: {type: String},
    icon: {type: String},
    showAllText: {
      type: String,
      default: 'Mehr Anzeigen'
    },
    route: {
      type: Object,
      default() {
        return {name: 'pageNotFound'}
      }
    }
  },
  computed: {
    style() {
      let bgColor = this.$finColors.background
      bgColor = (this.elevated || this.light ? this.$finColors.white : bgColor)
      bgColor = (this.dark ? this.$finColors.primaryDark : bgColor)

      return {
        position: 'relative',
        backgroundColor: bgColor
      }
    }
  },
  methods: {
    showAllClicked() {
      this.$emit('showAll')
      this.$router.push(this.route)
    }
  }
}
</script>

<style scoped>
div {
  width: 100%;
  position: relative;
}
</style>
